import { addDays, format, subDays } from "date-fns";
import { useContext } from "react";
import contextBabylon from "../../../../../../context/index.js";
import { required } from "../../../../../../helpers/forms/validate.js";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import useValue from "../../../../../../hooks/forms/useValue.js";
import { useSearcherActivitiesProps } from "../../context/index.js";
import useSearcherActivitiesDefaultValues from "../../hooks/useSearcherActivitiesDefaultValues.js";
const useCalendarInput = ()=>{
    const props = useSearcherActivitiesProps();
    const { config , rangeLimit =15  } = props ?? {};
    const { literals  } = config ?? {};
    const { calendarLabel =''  } = literals ?? {};
    const { Language ='default'  } = useContext(contextBabylon);
    const datesValue = useValue({
        name: 'dates'
    });
    const getRangeLimits = ()=>{
        if (datesValue?.length === 1) {
            return Array(rangeLimit + 1).fill(0).reduce((prev, _, i)=>{
                prev.push(format(addDays(datesValue[0], i), 'yyyy-MM-dd'));
                prev.push(format(subDays(datesValue[0], i), 'yyyy-MM-dd'));
                return prev;
            }, []);
        }
        return [];
    };
    const isMobile = useIsMobile();
    const commonProps = {
        name: 'dates',
        defaultValue: useSearcherActivitiesDefaultValues(props).calendar,
        validate: [
            required()
        ],
        mode: 'range',
        locale: Language.toLowerCase(),
        monthSelectorType: 'static',
        label: calendarLabel,
        checkOut: getRangeLimits()
    };
    if (isMobile) {
        const { config  } = props ?? {};
        const { literals  } = config ?? {};
        const { acceptLabel ='' , startDateLabel ='' , endDateLabel =''  } = literals ?? {};
        return {
            ...commonProps,
            showMonths: 12,
            modalTitle: literals?.calendarLabel,
            modalConfirm: acceptLabel,
            startDateLabel: startDateLabel,
            endDateLabel: endDateLabel
        };
    }
    return {
        ...commonProps,
        showMonths: 2
    };
};
export default useCalendarInput;

//# sourceMappingURL=useCalendarInput.js.map